import React, { useState, useEffect, useCallback } from "react";

const StatusBarPagination = ({ api }) => {
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  useEffect(() => {
    const updatePaginationInfo = () => {
      const totalRecords = api.paginationGetRowCount() || 0;
      const pages = api.paginationGetTotalPages();
      const current = api.paginationGetCurrentPage() + 1;
      const size = api.paginationGetPageSize();

      setCount(totalRecords);
      setTotalPages(pages);
      setCurrentPage(current);
      setPageSize(size);
    };

    api.addEventListener("paginationChanged", updatePaginationInfo);
    updatePaginationInfo();

    return () =>
      api.removeEventListener("paginationChanged", updatePaginationInfo);
  }, [api]);

  const onPageChange = (page) => {
    setCurrentPage(page);
    api.paginationGoToPage(page - 1);
  };

  const onBtFirst = useCallback(() => api.paginationGoToFirstPage(), [api]);
  const onBtLast = useCallback(() => api.paginationGoToLastPage(), [api]);
  const onBtNext = useCallback(() => api.paginationGoToNextPage(), [api]);
  const onBtPrevious = useCallback(
    () => api.paginationGoToPreviousPage(),
    [api]
  );

  // Generate page numbers dynamically with shifting effect
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxPagesToShow - 1);

    if (end - start < maxPagesToShow - 1) {
      start = Math.max(1, end - maxPagesToShow + 1);
    }

    for (let i = start; i <= end; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const startRecord = (currentPage - 1) * pageSize + 1;
  const endRecord = Math.min(startRecord + pageSize - 1, count);

  return (
    <div className="ag-status-name-value">
      <div>
        <span className="component">
          Showing {startRecord}-{endRecord} of {count}
        </span>
      </div>
      <div className="pagination_custom">
        <button
          onClick={onBtFirst}
          disabled={currentPage === 1}
          className="pagi navi"
        >
          «
        </button>
        <button
          onClick={onBtPrevious}
          disabled={currentPage === 1}
          className="pagi navi"
        >
          ‹
        </button>

        {generatePageNumbers().map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`pagi ${page === currentPage ? "active" : ""}`}
          >
            {page}
          </button>
        ))}

        <button
          onClick={onBtNext}
          disabled={currentPage === totalPages}
          className="pagi navi"
        >
          ›
        </button>
        <button
          onClick={onBtLast}
          disabled={currentPage === totalPages}
          className="pagi navi"
        >
          »
        </button>
      </div>

      <style>
        {`
          .pagi {
            padding: 5px 10px;
            margin: 2px;
            border: 1px solid #ccc;
            background-color: white;
            cursor: pointer;
          }
          .pagi.active {
            background-color: #007bff;
            color: white;
            font-weight: bold;
          }
          .pagi:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
            .pagination_custom button {
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0;
  min-width: 28px;
  height: 28px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #7b8794;
  border-radius: 4px;
  border: 1px solid #e3e6f4;
  -webkit-transition: all .2s ease-in-out;
  -o-transition: all ease-in-out .2s;
  transition: all .2s ease-in-out;
}
        `}
      </style>
    </div>
  );
};

export default StatusBarPagination;



// WEBPACK FOOTER //
// ./src/components/StatusBarPagination.js